<script>
  import Vue from 'vue'
  import api from '../api'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import BulmaPagination from '../components/BulmaPagination'
  import FilterBar from '../components/FilterBar'
  import swal from 'sweetalert'

  export default {
    data () {
      return {
        moreParams: {},
        css: {
          tableClass: 'table is-bordered is-striped',
          ascendingIcon: 'fa fa-chevron-up',
          descendingIcon: 'fa fa-chevron-down',
          sortHandleIcon: 'fa fa-bars',
        },
        columns: [
          'email',
          'role',
          {
            name: '__slot:actions',
            title: 'Actions'
          }
        ]
      }
    },

    computed: {
      httpOptions () {
        return {
          headers: {
            get: {
              Authorization: 'Bearer ' + this.$store.state.token.access_token
            }
          }
        }
      }
    },

    components: {
      Vuetable,
      BulmaPagination,
      FilterBar
    },

    methods: {
      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },

      onChangePage(page) {
        this.$refs.vuetable.changePage(page)
      },

      edit(address, idx) {
        this.$router.push(`/users/${address.id}/edit`)
      },

      bin(address, idx) {
        swal({
          title: "Are you sure?",
          showCancelButton: true,
          closeOnConfirm: false
        },
        async () => {
          await api.apios.delete(`/api/users/${address.id}`)
          swal.close()
          this.$refs.vuetable.refresh()
        });
      },

      onFilterSet(filterText) {
        this.moreParams = {
          'filter': filterText
        }
        Vue.nextTick(() => this.$refs.vuetable.refresh())
      }
    }
  }
</script>

<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Users</h1>
      <h2 class="subtitle">Manage users, clients and retouchers who can use the system.</h2>
      <hr />
      <filter-bar @filter="onFilterSet">
        <router-link to="/users/create" class="button is-primary">
          <span class="icon is-small">
            <i class="fa fa-plus"></i>
          </span>
          <span>New User</span>
        </router-link>
      </filter-bar>
      <vuetable 
        ref="vuetable" 
        api-url="/api/users" 
        :fields="columns"
        :http-options="httpOptions"
        :css="css"
        pagination-path=""
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
      >
        <template slot="actions" slot-scope="props">
          <a class="button is-outlined" @click="edit(props.rowData, props.rowIndex)">
            <i class="fa fa-pencil"></i>
          </a>
          <a class="button is-outlined" @click="bin(props.rowData, props.rowIndex)">
            <i class="fa fa-trash"></i>
          </a>
        </template>
      </vuetable>
      <bulma-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></bulma-pagination>
    </div>
  </section>
</template>
